export default __webpack_public_path__ + "static/media/Maria Ocean Fish in gravy.534a7591.png";